exports = module.exports = require("../../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".create-china-id-card[data-v-1db32f3e]{height:100%;width:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background-color:#555}.create-china-id-card>.container[data-v-1db32f3e]{cursor:pointer;padding:30px;width:800px;height:auto;background-color:#fff;border-radius:10px;box-shadow:0 0 20px rgba(0,0,0,.2)}.create-china-id-card p+p[data-v-1db32f3e]{margin-top:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1db32f3e","scoped":true,"hasInlineConfig":false}!./~/_less-loader@5.0.0@less-loader/dist/cjs.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/pages/CreateChinaIDCard.vue
// module id = 322
// module chunks = 0